// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"506":"5ac80f23c185bf37","689":"037ef473eaa710f4","926":"6c788a2aec8cb9d4"}[chunkId] + ".js";
};